export function normalizeMenuSections(result) {
    if (!Array.isArray(result)) {
        throw new Error("Invalid menu sections response");
    }

    return result.map((section) => ({
        id: section.id,
        title: section.title,
        type: section.type,
        price: section.price,
        data: Array.isArray(section.items) ? section.items : [],
    })).sort((a, b) => a.id - b.id);
}
